export interface DashboardTileLayoutConfiguration {
   dashboardTileLayoutConfigurationId: number;
   name: string | null;
   minWidth: number | null;
   minHeight: number | null;
   maxWidth: number | null;
   maxHeight: number | null;
   width: number;
   height: number;
   x: number;
   y: number;
   color: string | null;
   refreshTimeSeconds: number | null;
}

export function getRefreshTimeSecondsValue(value: number | string | null | undefined): number | null {
   if (value === null || value === undefined || value === '') {
      return null;
   }

   if (typeof value === 'number') {
      return Number.isInteger(value) ? value : null;
   }

   if (!/^\d+$/.test(value)) {
      return null;
   }

   return Number(value);
}
